import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BreadcrumbComponent } from '@app/shared/components/breadcrumb/breadcrumb.component';
import { RouterModule } from '@angular/router';
import { SharedModule } from '@app/shared/shared.module';
import { BreadcrumbService } from './services/breadcrumb.service';

@NgModule({
  imports: [CommonModule, RouterModule, SharedModule],
  declarations: [BreadcrumbComponent],
  exports: [BreadcrumbComponent],
  providers: [BreadcrumbService]
})
export class BreadcrumbModule {}
